<template>
  <div>
    <h1 id="jump-to-header">{{heading || generated_heading + " Update"}}</h1>
    <b-tabs
        active-nav-item-class="font-weight-bold text-uppercase text-warning"
        active-tab-class="font-weight-bold text-success"
        content-class="mt-3"
        lazy
      >
        <b-tab title="Settings" active>
          <storage-space-update :id="id" @gotAttrs="assignAttrs"></storage-space-update>
        </b-tab>
        <b-tab title="Items">
          <product-item-index
            :filtering="filtering"
            :ams_template="ams_product_item_template"
          ></product-item-index>
        </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import StorageSpaceUpdate from './StorageSpaceUpdate.vue'
import ProductItemIndex from './ProductItemIndex.vue'

export default {
  components: {
    StorageSpaceUpdate,
    ProductItemIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      generated_heading: undefined,
      filtering: {
        storage_space_ids: this.id
      },
      attrs: {},
      ams_product_item_template: {
        type: 'product-items',
        attributes: {
          'storage-space-id': this.id
        }
      }
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.generated_heading = description
      this.attrs = Object.assign( {}, attrs)
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>